import styled from "styled-components";
import Flex from "common/Boxes/Flex";
import Title from "common/Typography/Title";
import { useTheme } from "styled-components";
import ChangeTag from "common/Tags/ChangeTag";
import TextWithPrecisionAndIcon from "common/Text/TextWithPrecisionAndIcon";
import { getChangeValues } from "@shared/utils/charts";
import { PrecisionConfig } from "types";
import {
  FormattedChartDataPoint,
  IconType,
  PrecisionType,
} from "@shared/types";

interface ChangeInfoProps {
  title?: string | React.JSX.Element;
  data: FormattedChartDataPoint[];
  precisionSelector?: (state: any) => PrecisionConfig | undefined;
  precisionType: PrecisionType;
  iconType?: IconType;
  coin?: string;
  precisionConfig?: PrecisionConfig;
}

const ChangeInfo = ({
  title,
  data,
  precisionSelector,
  precisionType,
  iconType,
  coin,
  precisionConfig = undefined,
}: ChangeInfoProps) => {
  const appTheme = useTheme();
  const { value: changeValue, percent: changePercent } = getChangeValues(data);

  return (
    <Flex $alignItems="center">
      <Title
        type="secondary"
        level={3}
        style={
          appTheme.isNewLook
            ? {
                marginRight: 12,
                color: appTheme.colors.titleColor,
                fontSize: 14,
                fontWeight: appTheme.typography.fontWeights.SEMI_BOLD,
              }
            : { marginRight: 16 }
        }
      >
        {title}
      </Title>
      <ChangeWrapper>
        <TextWithPrecisionAndIcon
          text={changeValue}
          precisionSelector={precisionSelector}
          precisionType={precisionType}
          iconType={iconType}
          coinOrExchangeName={coin}
          round={true}
          precisionConfig={precisionConfig}
          textStyle={{
            color: appTheme.colors.primaryText,
            top: 1,
            position: "relative",
          }}
          iconStyle={{ color: appTheme.colors.primaryText }}
        />
        <ChangeTag value={changePercent} suffix="%" />
      </ChangeWrapper>
    </Flex>
  );
};

export default ChangeInfo;

const ChangeWrapper = styled(Flex)`
  font-size: 14px;
  font-weight: 500;
`;
